module.exports = __webpack_public_path__ + "static/media/shi.a46fa8e4.png";